module.exports = __webpack_public_path__ + "img/ditan_zc_wanglianzhong.abb5fc88.jpg";